import $ from "jquery";
import Logger from "../../common/logger";
import Field from "../field";

const PlaceAutocomplete = (($) => {
  const ComponentMap = {
    street_number: "short_name",
    route: "long_name",
    locality: "long_name",
    administrative_area_level_1: "short_name",
    country: "long_name",
    postal_code: "short_name",
    neighborhood: "long_name",
    subpremise: "short_name",
  };

  class PlaceAutocomplete extends Field {
    onPlaceChange() {
      const place = this._autocomplete.getPlace();
      const address = this.parseAddress(place);
      //   this._form.setValues(this.parseAddress(place));
      if (this._field.onChange) {
        this._field.onChange(address, place);
      }
    }
    parseAddress(place) {
      var addressType = null,
        i = 0,
        j = 0;

      const fieldNames = {
        ...{
          address: "propertyAddress",
          address2: "propertyAddress2",
          city: "propertyCity",
          state: "propertyStateID",
          postalCode: "propertyPostalCode",
        },
        ...(this._field.addressAlias ? this._field.addressAlias : {}),
      };
      const values = {};
      if (place.address_components) {
        for (const component of place.address_components) {
          for (const type of component.types) {
            if (!(type in ComponentMap)) continue;

            const value = component[ComponentMap[type]];
            switch (type) {
              case "street_number":
                values[fieldNames.address] = values[fieldNames.address]
                  ? `${value} ${values[fieldNames.address]}`
                  : value;
                break;

              case "route":
                values[fieldNames.address] = values[fieldNames.address]
                  ? `${values[fieldNames.address]} ${value}`
                  : value;
                break;

              case "locality":
              case "neighborhood":
                if (!values[fieldNames.city]) {
                  values[fieldNames.city] = value;
                }
                break;

              case "administrative_area_level_1":
                values[fieldNames.state] = value;
                break;

              case "postal_code":
                values[fieldNames.postalCode] = value;
                break;

              case "subpremise":
                values[fieldNames.address2] = value;
                break;
            }

            // break after first matching type for a given component
            break;
          }
        }
        this._place = place;
        return values;
      } else {
        Logger.warn("Invalid Location for AMP");
      }
    }

    render() {
      let id = this.getForm().getID() + "_field_" + this._field.name;

      this._element = document.createElement("div");
      this._element.classList.add("ion-form-group");
      this._element.classList.add("ion-form-group-text");

      // Label
      this._label = document.createElement("label");
      this._label.htmlFor = id;
      this._label.innerText = this._field.label;
      this._element.appendChild(this._label);

      // Default Value
      let defaultValue = this.getSetting("defaultValue");

      // Placeholder
      let placeholder = this.getSetting("placeholder", null);

      // Input
      this._input = document.createElement("input");
      this._input.id = id;
      this._input.type = "text";
      this._input.classList.add("ion-form-control");
      this._input.name = this._field.name;
      this._input.ariaLabel = this._field.label;
      if (placeholder) {
        this._input.placeholder = placeholder;
        this._input.ariaLabel = placeholder;
      }
      this._input.required = isRequired == 1;

      let isRequired = this.getSetting("isRequired", false);
      if (isRequired == "1") {
        this._element.classList.add("ion-is-required");
        this._input.ariaRequired = true;
      }

      this._element.appendChild(this._input);
      this._input.addEventListener("keydown", (e) => {
        if (e.keyCode == 13 && $(".pac-container:visible").length) {
          e.preventDefault();
          return false;
        }
      });

      this._autocomplete = new google.maps.places.Autocomplete(this._input, {
        types: ["address"],
      });
      this._autocomplete.addListener("place_changed", () => {
        this.onPlaceChange();
      });

      if (placeholder) {
        this._input.placeholder = placeholder;
      }

      if (defaultValue) {
        this._input.value = defaultValue;
      }

      // Instructions
      let instructions = this._renderInstructions();
      if (instructions) {
        this._element.appendChild(instructions);
      }

      this._renderMessages();
      if (this._messages) {
        this._element.appendChild(this._messages);
      }
    }
  }

  return PlaceAutocomplete;
})($);

export default PlaceAutocomplete;
